import { IPatient } from '../interface/patient'
export class Patient implements IPatient{
    constructor(
    public PatientId : number,
    public PatientFirstName : string,
    public PatientLastName : string,
    public Patient_PIN : string,
    public PatientPassword : string,
    public PatientAadharID : number,
    public PatientGender : string,
    public PatientDOB : string,
    public PatientReferedBy : string,
    public PatientBloodGroup : string,
    public PatientFamily : string,
    public PatientPrimaryMobNo : number,
    public PatientSecondaryMobNo : number,
    public PatientLanguagePreference : string,
    public PatientLandLineNo : number,
    public PatientEmailAddress : string,
    public PatientStreetAddress : string,
    public PatientLocality : string,
    public PatientCity : string,
    public PatientPinCode : number,
    public MedicalHistoryId : number,
    public MedicalHistoryText : string, public PatientAge?: number){
    }

}
export class PatientMedicalHistory {
    constructor( public PatientId : number, public MedicalHistoryId : number, public PatientMedicalHistoryDetail : string){
        
    }
}

export class Search {
    constructor( public text : string){}
}


// WEBPACK FOOTER //
// ./src/app/section/patient/model/patient.ts